
export class FileType {

    static readonly Xml = new FileType("xml", ["text/xml"]);
    static readonly Json = new FileType("json", ["application/json"]);
    static readonly Txt = new FileType("txt", ["text/plain"]);
    static readonly Csv = new FileType("csv", ["application/vnd.ms-excel", "text/csv"]);
    static readonly Pfx = new FileType("pfx", ["application/x-pkcs12"]);
    static readonly Crt = new FileType("crt", ["application/x-x509-ca-cert"]);
    static readonly Cer = new FileType("cer", ["application/x-x509-ca-cert"]);
    static readonly Xls = new FileType("xls", ["application/vnd.ms-excel"]);
    static readonly Xlsx = new FileType("xlsx", ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]);
    static readonly P12 = new FileType("p12", ["application/x-pkcs12"]);

    private constructor(public readonly extension: string, public readonly mimeTypes: string[]) {

    }
}